import { useEffect, useState } from "react";
import { Select } from "@chakra-ui/react";
import client from "../../helpers/Client";

export function RawResellerSelect({
  reseller,
  setReseller,
  resellers,
  ...rest
}) {
 /*
  A reseller select component that requires resellers to be passed in as a prop.
  For automatic city list population, use the ResellerSelect component instead.
  */
  useEffect(() => {
    if (resellers?.length === 1) {
      // setReseller(resellers[0].url);
    }
  }, [resellers, setReseller]);
  return (
    <Select
      value={reseller}
      onChange={(e) => {
        setReseller(e.target.value);
      }}
      {...rest}
    >
      <option value="">Tümü</option>
      {resellers &&
        resellers.map((_option) => (
          <option key={_option.url} value={_option.url}>
            {_option.name}
          </option>
        ))}
    </Select>
  );
}

const ResellerSelect = ({ reseller, setReseller, ...rest}) => {
  const [resellers, setResellers] = useState([]);
  useEffect(() => {
    client
      .get("/resellers/")
      .then((response) => setResellers(response.data))
      .catch((error) => console.error("Error fetching resellers:", error));
  }, []);
  return <RawResellerSelect {...{reseller, setReseller, resellers , ...rest}} />;
};

export default ResellerSelect;